import { CSSProperties } from 'react'
import { BaseProps } from '@/components/types'
import { CardListItem, Box, Button, Typography } from '@/components'
import { REVIEW_LIST, REVIEW_REQUEST, REVIEW_UNDER } from '@/constants/prop/ItemProcess'
import { SelectUtil } from '@/util'

function ItemProcessBox ( props: ItemProcessBox ) {
    const {
        className, style, itemProcess,
        ...rest
    } = props
    const boxBaseStyle: () => CSSProperties = () => {
        const { value: reviewUnderValue } = REVIEW_UNDER
        return {
            ...style,
            paddingLeft: '10px',
            paddingRight: '10px',
            paddingTop: '16px',
            paddingBottom: '16px',
            borderRadius: '4px',
            border: '1px solid rgb(2, 136, 209)',
            color: itemProcess === reviewUnderValue ? 'white' : 'rgb(2, 136, 209)',
            textAlign: 'center',
            cursor: 'default',
            backgroundColor: itemProcess !== reviewUnderValue ? 'white' : 'rgb(2, 136, 209)',
        }
    }
    return <Box
        { ...rest }
        component="div"
        className={ className }
        sx={ boxBaseStyle }
    >
        <Typography
            sx={ { fontSize: '13px', fontWeight: 500 } }
        >
            { REVIEW_LIST.find( ( { value } ) => value === itemProcess )?.name || '' }
        </Typography>
    </Box>
}

function RequestItem ( props: RequsetItemProps ) {
    const {
        data, marginTop, marginBottom, index,
        onClickDetail,
        ...rest
    } = props
    const {
        propertyNo, propertyNm, investConfirmDate, advisorConfirmDate, itemProcess
    } = data
    const { value: reviewRequestValue } = REVIEW_REQUEST

    const listItemInfo = () => {
        return <>
            <span>{ `요청 일시: ${investConfirmDate || ''}` }</span>
            <br/>
            <span>{ `변경 일시: ${advisorConfirmDate || ''}` }</span>
            <br/>
        </>
    }

    return (
        <CardListItem
            { ...rest }
            style={ { backgroundColor: '#f3f3f9' } }
            primaryText={ <span>{ `물건명 : ${ propertyNm || '' }` }</span> }
            secondary={ listItemInfo() }
            leftContents={
                <Typography sx={ { width: 50 } }>
                    { index + 1 }
                </Typography>
            }
            rightContents={
                itemProcess !== reviewRequestValue ?
                    <Box className="flex w100p" sx={ { alignItems: 'center' } }>
                        <ItemProcessBox className="w50p" itemProcess={ SelectUtil.create( REVIEW_LIST ).printName( itemProcess ) } />
                        <Button
                            className="w50p"
                            size="small"
                            onClick={ () => { onClickDetail && onClickDetail( data ) } }
                        >
                            상세
                            <br/>
                            보기
                        </Button>
                    </Box> :
                    <Box className="flex h100p" sx={ { alignItems: 'center' } }>
                        <ItemProcessBox className="w100p" itemProcess={ itemProcess } />
                    </Box>
            }
        />
    )
}

export default RequestItem


export interface ItemProcessBox extends BaseProps {
    itemProcess: string
}

export interface IRequestItem {
    propertyId: number
    propertyNo: string
    propertyNm: string
    investConfirmDate: string
    advisorConfirmDate: string
    itemProcess: string
}

export interface RequsetItemProps extends BaseProps {
    data: IRequestItem
    marginTop?: string | number
    marginBottom?: string | number
    onClickDetail?: ( data: IRequestItem ) => void
}